module.exports = __webpack_public_path__ + "img/icon-connect.8cda32ed.svg";